import { BookIcon } from '@zep-us/zus';
import { Trans, useTranslation } from 'next-i18next';

/**
 * 검색 전 초기 상태를 표시하는 플레이스홀더 컴포넌트
 */
export const SearchPlaceholder = () => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex flex-col items-center justify-center gap-lg pt-xl" data-sentry-component="SearchPlaceholder" data-sentry-source-file="SearchPlaceholder.tsx">
      <BookIcon width={70} height={70} fill={'#1C1B1F12'} data-sentry-element="BookIcon" data-sentry-source-file="SearchPlaceholder.tsx" />
      <div className="flex flex-col gap-sm text-center">
        <h6 className="text-heading-md-bold text-neutral">
          {t('build:build.standard.search.placeholder.title')}
        </h6>
        <div className="flex flex-col gap-lg text-body-md-bold text-alternative opacity-[0.72]">
          <div>
            <p>
              <Trans i18nKey="build:build.standard.search.supportAll" components={{
              strong: <strong className="text-strong" />
            }} data-sentry-element="Trans" data-sentry-source-file="SearchPlaceholder.tsx" />
            </p>
            <p>{t('build:build.standard.search.guide')}</p>
          </div>
          <p>{t('build:build.standard.search.example')}</p>
        </div>
      </div>
    </div>;
};